import AboutSlides from './AboutSlides';
import ServicesPinnedSection from './ServicesPinnedSection';

function DemoBlock({ n }) {
  return (
    <div style={{
      minHeight: '40vh',
      background: n % 2 === 0 ? '#f3f4f6' : '#e0e7ef',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '2rem',
      color: '#1d354d',
      fontWeight: 700,
      borderBottom: '1px solid #d1d5db',
    }}>
      Demo Block {n}
    </div>
  );
}

export default function AboutSection() {
  return (
    <>
      <AboutSlides />
      {/* <ServicesPinnedSection /> */}
    </>
  );
}
